import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { addInsurance, getInsuranceList, updateInsurance } from '../../../../../repository/PatientsRepo'
import { useOutletContext, useParams } from 'react-router-dom'
import { getListCountry, getListState } from '../../../../../repository/CountryStateRepo'
import { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import { InsuranceErrorOnchange } from '../../../../../components/Error/error'
import { scrollIntoViewHelper, uploadLogo } from '../../../../../utils/utils'
import moment from 'moment-timezone'

export const useInsurance = () => {
    const { id, patientId } = useParams()
    const [insuranceList, setInsuranceList] = useState([])
    const [spinner, setSpinner] = useState(false)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10 })
    const [totalCount, settotalCount] = useState(0)
    const [notesModel, setNotesModel] = useState({ open: false, data: {} })
    const [validation, setValidation] = useState({})
    const [ListState, setListState] = useState([])
    const [ListCountry, setListCountry] = useState([])
    const [insuranceDetailsModel, setInsuranceDetailsModel] = useState({ open: false, data: {} })
    const [ListStateInsurrance, setListStateInsurrance] = useState([])
    const [date, setdate] = useState({ date_of_birth: null, issue_date: null })
    const { data } = useOutletContext()
    const [userIdCard, setUserIdCard] = useState([])
    const [coverage, setcoverage] = useState('Primary')
    const [searchFilter, setSearchFilter] = useState({ search_coverage: 'All', isActive: 'All' })
    const [userIdCardForm, setUserIdCardForm] = useState({ title: '', image: null })
    const [addInsuranceData, setAddInsuranceData] = useState({
        mobile_no: '',
        insurance_type: '',
        insurance_plan_type: '',
        insurance_address: '',
        insurance_country: '',
        insurance_state: '',
        insurance_city: '',
        insurance_zip_code: '',
        payer_id: '',
        copay: '',
        note: '',
        insurance_company_id: null,
    })

    const [addSubscriberData, setAddSubscriberData] = useState({
        subscriber_first_name: '',
        subscriber_last_name: '',
        subscriber_gender: '',
        subscriber_id: '',
        group_number: '',
        relationship: '',
        subscriber_address: '',
        subscriber_country: '',
        subscriber_state: '',
        subscriber_city: '',
        subscriber_zip_code: '',
    })

    const insurancListHeadCells = [
        {
            id: 'index',
            numeric: true,
            disablePadding: true,
            label: '#',
            isShorted: false,
        },
        {
            id: 'insurance_name',
            numeric: false,
            disablePadding: false,
            label: 'Insurance Name',
            isShorted: false,
        },
        {
            id: 'address',
            numeric: false,
            disablePadding: false,
            label: 'Address',
            isShorted: false,
        },
        {
            id: 'mobile_no',
            numeric: false,
            disablePadding: false,
            label: 'Contact',
            isShorted: false,
        },
        {
            id: 'coverage',
            numeric: false,
            disablePadding: false,
            label: 'Coverage',
            isShorted: false,
        },
        {
            id: 'insurance_plan_type',
            numeric: false,
            disablePadding: false,
            label: 'Plan Type',
            isShorted: false,
        },
        {
            id: 'insurance_type',
            numeric: false,
            disablePadding: false,
            label: 'Type',
            isShorted: false,
        },
        {
            id: 'isActive',
            numeric: false,
            disablePadding: false,
            label: 'Status',
            isShorted: false,
        },
        {
            id: 'action',
            numeric: false,
            disablePadding: false,
            label: 'Action',
            isShorted: false,
        },
        {
            id: 'note',
            numeric: false,
            disablePadding: false,
            label: 'Note',
            isShorted: false,
        },
    ]

    const getInsurance = useCallback(
        async (filter = searchFilter) => {
            let payload = {
                patient_id: patientId,
                page: controller.page,
                count: controller.rowsPerPage,
                coverage: filter.search_coverage !== 'All' ? filter.search_coverage : undefined,
                isActive: filter.isActive !== 'All' ? filter.isActive : undefined,
            }
            setSpinner(true)
            try {
                let response = await getInsuranceList(payload)
                if (response.status_code === 200) {
                    setInsuranceList(response.data)
                    settotalCount(response.totalDocs)
                } else {
                    setInsuranceList([])
                    settotalCount(0)
                }
                setSpinner(false)
            } catch (error) {
                toast.error('Failed to fetch insurance list')
                setSpinner(false)
            }
        },
        [patientId, controller.page, controller.rowsPerPage]
    )

    const changeStatusInsurance = async (data) => {
        let payload = { _id: data._id, isActive: data.isActive ? 'false' : 'true' }
        setSpinner(true)
        try {
            let response = await updateInsurance(payload)
            if (response.status_code === 200) getInsurance()
            setSpinner(false)
        } catch (error) {
            toast.error(error)
            setSpinner(false)
        }
    }

    const handleInsuranceDataAutoFill = (insuranceDetails) => {
        setAddInsuranceData((prev) => ({
            ...prev,
            mobile_no: insuranceDetails?.mobile_number ? insuranceDetails?.mobile_number : '',
            insurance_address: insuranceDetails?.address ? insuranceDetails?.address : '',
            insurance_country: insuranceDetails?.country ? insuranceDetails?.country : '',
            insurance_state: insuranceDetails?.state ? insuranceDetails?.state : '',
            insurance_city: insuranceDetails?.city ? insuranceDetails?.city : '',
            insurance_zip_code: insuranceDetails?.postalCode ? insuranceDetails?.postalCode : '',
            payer_id: insuranceDetails?.payer_id ? insuranceDetails?.payer_id : '',
        }))

        handleChangeCountryForInsurance(insuranceDetails?.country)
    }

    const handleChangeCountryForInsurance = async (value) => {
        try {
            let response = await getListState({
                countryId: value,
            })
            setListStateInsurrance(response.data.data)
        } catch (error) {
            toast.error(error)
        }
    }

    const setInsuranceData = (data) => {
        setAddSubscriberData({
            subscriber_first_name: data?.subscriber_first_name ? data?.subscriber_first_name : '',
            subscriber_last_name: data?.subscriber_last_name ? data?.subscriber_last_name : '',
            subscriber_gender: data?.subscriber_gender ? data?.subscriber_gender : '',
            subscriber_id: data?.subscriber_id ? data?.subscriber_id : '',
            group_number: data?.group_number ? data?.group_number : '',
            relationship: data?.relationship ? data?.relationship : '',
            subscriber_address: data?.subscriber_address ? data?.subscriber_address : '',
            subscriber_country: data?.subscriber_country ? data?.subscriber_country : '',
            subscriber_state: data?.subscriber_state ? data?.subscriber_state : '',
            subscriber_city: data?.subscriber_city ? data?.subscriber_city : '',
            subscriber_zip_code: data?.subscriber_zip_code ? data?.subscriber_zip_code : '',
        })
        setUserIdCard(data?.ins_card?.length ? data?.ins_card : userIdCard)
        setdate({ date_of_birth: data?.date_of_birth, issue_date: data?.issue_date })
        setAddInsuranceData({
            mobile_no: data?.mobile_no ? data?.mobile_no : '',
            insurance_type: data?.insurance_type ? data?.insurance_type : '',
            insurance_plan_type: data?.insurance_plan_type ? data?.insurance_plan_type : '',
            insurance_address: data?.insurance_address ? data?.insurance_address : '',
            insurance_country: data?.insurance_country ? data?.insurance_country : '',
            insurance_state: data?.insurance_state ? data?.insurance_state : '',
            insurance_city: data?.insurance_city ? data?.insurance_city : '',
            insurance_zip_code: data?.insurance_zip_code ? data?.insurance_zip_code : '',
            payer_id: data?.payer_id ? data?.payer_id : '',
            copay: data?.copay?.amount?.toString() || '0',
            note: data?.note ? data?.note : '',
            insurance_company_id: data?.insurance_company_id ? data?.insurance_company_id : null,
        })
    }

    useEffect(() => {
        handleChangeCountry(addSubscriberData?.subscriber_country)
    }, [addSubscriberData?.subscriber_country])
    useEffect(() => {
        handleChangeCountryForInsurance(addInsuranceData?.insurance_country)
    }, [addInsuranceData?.insurance_country])

    const handleInputChange = (event, type) => {
        const { name, value } = event.target
        if (type === 'SUBSCRIBER') {
            setAddSubscriberData((prevProps) => ({
                ...prevProps,
                [name]: value,
            }))
        } else {
            setAddInsuranceData((prevProps) => ({
                ...prevProps,
                [name]: value,
            }))
        }
        // error message!
        if (name !== 'insurance_company_id') {
            validation[name] = InsuranceErrorOnchange[name]
        } else {
            delete validation[name]
        }
        if (name === 'note') {
            delete validation?.note
        }
        if (name === 'mobile_no') {
            if (value && isValidPhoneNumber(value)) {
                delete validation.mobile_no
            } else {
                validation.mobile_no = ' Please enter a valid contact number'
            }
        }

        if (name === 'insurance_company_id') handleInsuranceDataAutoFill(value)

        setValidation({ ...validation })
    }

    const handleDateChange = (event, name) => {
        setdate((prevProps) => ({ ...prevProps, [name]: event }))
        // error message!
        if (name === 'date_of_birth') {
            if (date?.date_of_birth === null) {
                validation['date_of_birth'] = InsuranceErrorOnchange['date_of_birth']
            } else {
                delete validation['date_of_birth']
            }
        }
        setValidation({ ...validation })
    }

    const handleChangeCountry = async (value) => {
        try {
            let response = await getListState({ countryId: value })
            setListState(response.data.data)
        } catch (error) {
            toast.error(error)
        }
    }

    const isValid = () => {
        if (!addSubscriberData?.subscriber_first_name.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_first_name'])
        }
        if (!addSubscriberData.subscriber_last_name.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_last_name'])
        }
        if (!addSubscriberData.subscriber_gender.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_gender'])
        }
        if (!addSubscriberData.subscriber_id.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_id'])
        }
        if (!addSubscriberData.relationship.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['relationship'])
        }
        if (!addSubscriberData.subscriber_address.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_address'])
        }
        if (!addSubscriberData.subscriber_country.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_country'])
        }
        if (!addSubscriberData.subscriber_state.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_state'])
        }
        if (!addSubscriberData.subscriber_city.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_city'])
        }
        if (!addSubscriberData.subscriber_zip_code.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['subscriber_zip_code'])
        }
        if (!addInsuranceData.insurance_type.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_type'])
        }
        if (!addInsuranceData.insurance_plan_type.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_plan_type'])
        }
        if (!addInsuranceData.insurance_address.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_address'])
        }
        if (!addInsuranceData.insurance_country.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_country'])
        }
        if (!addInsuranceData.insurance_state.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_state'])
        }
        if (!addInsuranceData.insurance_city.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_city'])
        }
        if (!addInsuranceData.insurance_zip_code.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['insurance_zip_code'])
        }
        if (!addInsuranceData.payer_id.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['payer_id'])
        }
        if (!addInsuranceData.copay.toString()?.length) {
            return toast.warn(InsuranceErrorOnchange['copay'])
        }
        if (!isValidPhoneNumber(addInsuranceData.mobile_no) || !addInsuranceData.mobile_no) {
            return toast.warn('Please enter a valid contact number')
        } else {
            delete validation.mobile_no
        }

        if (!addInsuranceData.insurance_company_id) {
            return toast.warn('Please select insurance company')
        }
        if (!date.date_of_birth) {
            return toast.warn('Date  is required')
        }
        scrollIntoViewHelper(validation)
        setValidation({ ...validation })
        return true
    }

    const UpdateInsurance = (e) => {
        e.preventDefault()
        isValid() === true && updateInsuranceData()
    }

    const AddInsurancefun = async () => {
        try {
            setSpinner(true)
            let payload = {
                ...addSubscriberData,
                ...addInsuranceData,
                insurance_company_id: addInsuranceData?.insurance_company_id?._id,
                date_of_birth: moment(date.date_of_birth).format('MM/DD/YYYY'),
                issue_date: moment(date.issue_date).utc(),
                clinic_id: id,
                patient_id: patientId,
                coverage: coverage,
                mobile_no: addInsuranceData?.mobile_no,
                mobile_without_code: addInsuranceData?.mobile_no,
                copay: { amount: addInsuranceData.copay },
                ins_card: userIdCard,
            }
            await addInsurance(payload)
            setInsuranceDetailsModel({ open: false, data: {} })
            setdate({ date_of_birth: null, issue_date: null })
            getInsurance()
            toast.success('Insurance Added Successfully')
        } catch (error) {
            toast.error(error.message)
        }
        setSpinner(false)
    }

    const submit = (e) => {
        e.preventDefault()
        isValid() === true && AddInsurancefun()
    }

    const getCountryList = async () => {
        try {
            let response = await getListCountry({ search: '' })
            setListCountry(response.data.data)
        } catch (error) {
            toast.error(error)
        }
    }

    const handleUploadChange = (event) => {
        const { name, value } = event.target
        if (name === 'image') uploadUserIdImage(event)
        else setUserIdCardForm((prev) => ({ ...prev, [name]: value }))
    }

    const saveAndAddNew = () => {
        if (!userIdCardForm?.title) return toast.warn('Please enter title to add new')
        if (!userIdCardForm?.image) return toast.warn('Please upload image to add new')
        let tempUserIdCard = userIdCard
        tempUserIdCard.push({ title: userIdCardForm?.title, image: userIdCardForm?.image })
        setUserIdCard(tempUserIdCard)
        document.getElementById('insurance-card-upload').value = null
        setUserIdCardForm({ title: '', image: null })
    }

    const handleRemoveDocument = (index) => {
        if (typeof index === 'number') {
            let tempUserIdCard = userIdCard
            tempUserIdCard.splice(index, 1)
            tempUserIdCard.length > 0 ? setUserIdCard(tempUserIdCard) : setUserIdCard([])
        } else {
            document.getElementById('insurance-card-upload').value = null
            setUserIdCardForm((prev) => ({ ...prev, image: null }))
        }
    }

    const uploadUserIdImage = async (event) => {
        setSpinner(true)
        try {
            let response = await uploadLogo(event, 'patient')
            if (response.status_code === 200) setUserIdCardForm((prev) => ({ ...prev, image: response?.data?.name }))
        } catch (error) {
            toast.error(error)
        }
        setSpinner(false)
    }

    const updateInsuranceData = async () => {
        try {
            setSpinner(true)
            let response = await updateInsurance({
                ...addSubscriberData,
                ...addInsuranceData,
                date_of_birth: moment(date.date_of_birth).format('MM/DD/YYYY'),
                issue_date: moment(date.issue_date).utc(),
                clinic_id: id,
                patient_id: patientId,
                mobile_no: addInsuranceData?.mobile_no && formatPhoneNumberIntl(addInsuranceData?.mobile_no),
                // mobile_without_code: mobile_withoutcode,
                _id: insuranceDetailsModel.data?._id,
                coverage: insuranceDetailsModel.data?.coverage,
                copay: { amount: addInsuranceData.copay },
                ins_card: insuranceDetailsModel.data?.ins_card,
            })
            setInsuranceDetailsModel({ open: false, data: {} })
            setdate({ date_of_birth: null, issue_date: null })
            toast.success(response.data)
        } catch (error) {
            toast.error(error.message)
        }
        setSpinner(false)
    }

    const autoFill = () => {
        setAddSubscriberData((pre) => ({
            ...pre,
            subscriber_first_name: data?.first_name,
            subscriber_last_name: data?.last_name,
            subscriber_gender: data?.gender,
            relationship: data?.contact?.prefered?.relation,
            subscriber_address: data?.address,
            subscriber_country: data?.country?._id,
            subscriber_state: data?.state?._id,
            subscriber_city: data?.city,
            subscriber_zip_code: data?.postal_code,
        }))
        setdate({
            date_of_birth: data?.date_of_birth,
            issue_date: null,
        })
        handleChangeCountry(data?.country?._id)
    }

    const handleSearchFilter = (e) => {
        const { name, value } = e.target
        setSearchFilter((prev) => ({ ...prev, [name]: value }))
    }

    const resetFilter = () => {
        setSearchFilter({ search_coverage: 'All', isActive: 'All' })
        getInsurance({ search_coverage: 'All', isActive: 'All' })
    }

    useEffect(() => {
        getInsurance()
    }, [getInsurance])

    return {
        data: {
            insuranceList,
            insurancListHeadCells,
            spinner,
            controller,
            totalCount,
            notesModel,
            ListStateInsurrance,
            insuranceDetailsModel,
            addInsuranceData,
            ListState,
            addSubscriberData,
            date,
            ListCountry,
            userIdCard,
            userIdCardForm,
            coverage,
            searchFilter,
        },
        method: {
            refetch: getInsurance,
            setController,
            setInsuranceData,
            handleInputChange,
            changeStatusInsurance,
            setNotesModel,
            setInsuranceDetailsModel,
            handleInsuranceDataAutoFill,
            setdate,
            handleDateChange,
            handleChangeCountryForInsurance,
            handleChangeCountry,
            UpdateInsurance,
            getCountryList,
            handleUploadChange,
            saveAndAddNew,
            handleRemoveDocument,
            submit,
            autoFill,
            setcoverage,
            setUserIdCard,
            handleSearchFilter,
            resetFilter,
        },
    }
}
